/**
 * Brand decorative SVG accents:
 *  - LightningBolt: B&W checkered lightning bolt for tiny highlights
 *  - CheetahCorner: faded cheetah print accent for corners/dividers
 *  - StarSpark: small spark accent
 */

export function LightningBolt({ size = 28, className = "" }) {
  // Bolt path masked with a 4x4 checker pattern.
  const id = `bolt-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <svg viewBox="0 0 32 48" width={size} height={(size * 48) / 32} className={className} aria-hidden>
      <defs>
        <pattern id={id} width="4" height="4" patternUnits="userSpaceOnUse">
          <rect width="4" height="4" fill="#ffffff" />
          <rect width="2" height="2" fill="#1c1815" />
          <rect x="2" y="2" width="2" height="2" fill="#1c1815" />
        </pattern>
      </defs>
      <path
        d="M18 0 L0 26 L12 26 L8 48 L32 18 L20 18 L24 0 Z"
        fill={`url(#${id})`}
        stroke="#1c1815"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheetahDivider({ className = "" }) {
  return (
    <div className={`relative w-full h-px ${className}`}>
      <div className="absolute inset-0 brand-divider" />
      <div
        className="absolute left-1/2 -translate-x-1/2 -top-2 h-4 w-24 bg-cheetah rounded-full pointer-events-none"
        style={{ opacity: 0.55 }}
      />
    </div>
  );
}

export function StarSpark({ size = 14, className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden>
      <path
        d="M12 0 L13.8 9.2 L24 12 L13.8 14.8 L12 24 L10.2 14.8 L0 12 L10.2 9.2 Z"
        fill={color}
      />
    </svg>
  );
}

export function CheetahCorner({ position = "top-right", size = 120, opacity = 0.18 }) {
  const map = {
    "top-right": "absolute top-0 right-0 origin-top-right",
    "top-left": "absolute top-0 left-0 origin-top-left",
    "bottom-right": "absolute bottom-0 right-0 origin-bottom-right",
    "bottom-left": "absolute bottom-0 left-0 origin-bottom-left",
  };
  return (
    <div
      className={`${map[position]} pointer-events-none bg-cheetah`}
      style={{ width: size, height: size, opacity, maskImage: "radial-gradient(circle at center, black, transparent 70%)", WebkitMaskImage: "radial-gradient(circle at center, black, transparent 70%)" }}
      aria-hidden
    />
  );
}
